<mat-button-toggle-group
  [value]="selectedTabName$ | async"
  (change)="setSelectedTab($event.value)"
>
  @for (button of buttons; track button) {
    <mat-button-toggle
      class="toolbar-button underlined"
      [value]="button.tabName"
      [matTooltip]="button.tooltip"
    >
      <mat-icon [h3CustomIcon]="button.icon"></mat-icon>
    </mat-button-toggle>
  }
</mat-button-toggle-group>

@switch (selectedTabName$ | async) {
  @case (tabName3d) {
    <h3-view-settings3d h3ScrollEnabler></h3-view-settings3d>
  }
  @case (tabName2d) {
    <h3-view-settings2d h3ScrollEnabler></h3-view-settings2d>
  }
  @case (tabNameLayout) {
    <h3-layout-settings h3ScrollEnabler></h3-layout-settings>
  }
  @case (tabNameROI) {
    <h3-region-of-interest-settings
      h3ScrollEnabler
    ></h3-region-of-interest-settings>
  }
}
